/**
 * お気に入り(Swym Wishlist)ページ用のカスタマイズ
 * 1) 「Add to cart」ボタンの表示文言を「購入する」に統一する
 * 2) カートに追加されたら、自動的にカートページへ遷移する
 *    （お気に入りからは削除しない = Swym標準のAdd to Cartボタンの挙動をそのまま利用）
 */
(function () {
  var BUTTON_LABEL = '購入する';

  function relabelButtons() {
    document.querySelectorAll('.swym-add-to-cart-btn').forEach(function (btn) {
      if (btn.textContent.trim() !== BUTTON_LABEL) {
        btn.textContent = BUTTON_LABEL;
      }
    });
  }

  function watchForButtons() {
    // Swymはウィジェットを非同期でDOMに描画するため、
    // 出現を監視して文言を上書きする
    relabelButtons();
    var observer = new MutationObserver(relabelButtons);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function registerAddedToCartRedirect(swat) {
    swat.evtLayer.addEventListener('sw:addedtocart', function () {
      window.location.href = '/cart';
    });
  }

  function init() {
    watchForButtons();

    if (window._swat) {
      registerAddedToCartRedirect(window._swat);
    } else {
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(registerAddedToCartRedirect);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
